<template>
  <kst-print-table :data="items">
    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="SlsItemCatalog.DispatchID.PrintLabel"
    >
      <kst-value :field="column.field" :data="row" :catalog="SlsItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku-large"
      field="SKU"
      :label="SlsItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="SlsItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty-print"
      field="Qty"
      :label="SlsItemCatalog.Qty.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="SlsItemCatalog">
        <kst-value field="Packaging" :data="row" :catalog="SlsItemCatalog"/>
      </kst-value>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="SlsItemCatalog.SellPrice.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="SlsItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-if="hasItemLevelDisc && hasDiscountedItem"
      v-slot="{ column, row }"
      cell-class="ks-col-disc-value"
      field="DiscPercent"
      label="Diskon"
    >
      <template v-if="row.DiscPercent > 0">
        <kst-value :field="column.field" :data="row" :catalog="SlsItemCatalog"/>
      </template>
      <template v-else-if="row.DiscValue > 0">
        <kst-value field="DiscValue" :data="row" :catalog="SlsItemCatalog"/>
      </template>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="TotalAfterDisc"
      :label="SlsItemCatalog.Total.Label"
    >
      <kst-value field="TotalAfterDisc" :data="getRowDisplay(row)" :catalog="SlsItemCatalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import AppModuleAttr from "../../../services/App/AppModuleAttr.js";
import SlsItemCatalog from "../SlsItemCatalog.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    SlsItemCatalog: SlsItemCatalog
  }),
  computed: {
    hasItemLevelDisc() {
      return this.$kst.Access.hasModuleAttr(AppModuleAttr.ItemLevelDisc_Act_List);
    },
    // tampilkan kolom diskon hanya bila minimal satu baris item berdiskon
    hasDiscountedItem() {
      return Array.isArray(this.items) && this.items.some(
        (row) => (row.DiscPercent || 0) > 0 || (row.DiscValue || 0) > 0
      );
    }
  },
  methods: {
    // Sub Total per baris: pakai TotalAfterDisc jika tersimpan, fallback
    // Total (Qty x Harga) agar tidak kosong untuk baris tanpa diskon item
    // maupun dokumen lama yang belum menyimpan TotalAfterDisc.
    getRowDisplay(row) {
      const totalAfterDisc = row.TotalAfterDisc !== null &&
        row.TotalAfterDisc !== undefined ? row.TotalAfterDisc : null;
      const total = row.Total !== null && row.Total !== undefined
        ? row.Total : null;

      return {
        ...row,
        TotalAfterDisc: totalAfterDisc !== null
          ? totalAfterDisc
          : (total !== null ? total : (row.Qty || 0) * (row.SellPrice || 0))
      };
    }
  }
}
</script>